// Cues are stored as an array of strings but edited as a single comma-separated
// text input throughout the admin UIs. To allow a literal comma inside a cue
// (e.g. ", and"), backslash works as an escape character:
//
//   "and,\, and"  parses to  ["and", ", and"]
//
// `\\` escapes a literal backslash. Any other `\X` sequence yields just `X`,
// so older cue strings (which contain no backslashes) round-trip unchanged.

export function parseCues(input: string): string[] {
  const cues: string[] = [];
  let current = '';
  let escaped = false;
  for (const ch of input) {
    if (escaped) {
      current += ch;
      escaped = false;
    } else if (ch === '\\') {
      escaped = true;
    } else if (ch === ',') {
      cues.push(current);
      current = '';
    } else {
      current += ch;
    }
  }
  if (escaped) current += '\\';
  cues.push(current);
  return cues;
}

export function serializeCues(cues: string[]): string {
  return cues.map(cue => cue.replace(/[\\,]/g, m => `\\${m}`)).join(',');
}
